// src/contexts/geral/PrinterOSContext.js
import React, { createContext, useCallback, useContext } from 'react';
import { obterPdfOrdemServico } from '../../services/servicos/OrdemServicoService';
import { useMessage } from './MessageContext';

const PrinterOSContext = createContext();

export const PrinterOSProvider = ({ children }) => {
  const { showMessage } = useMessage();

  const imprimirOrdemServicoPDF = useCallback(async (ordemServicoId, paperWidthMm = 75) => {
    try {
      if (!ordemServicoId) {
        showMessage('Ordem de serviço não informada para impressão.', 'warning');
        return false;
      }

      const pdfBlob = await obterPdfOrdemServico(ordemServicoId, paperWidthMm);
      const blob = pdfBlob?.type === 'application/pdf'
        ? pdfBlob
        : new Blob([pdfBlob], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(blob);
      const frameId = 'ordem-servico-pdf-print-frame';

      document.getElementById(frameId)?.remove();

      const frame = document.createElement('iframe');
      frame.id = frameId;
      frame.title = 'Impressão de Ordem de Serviço';
      frame.style.position = 'fixed';
      frame.style.right = '0';
      frame.style.bottom = '0';
      frame.style.width = '1px';
      frame.style.height = '1px';
      frame.style.border = '0';
      frame.style.opacity = '0';
      frame.style.pointerEvents = 'none';
      frame.src = pdfUrl;
      document.body.appendChild(frame);

      let impressaoSolicitada = false;
      let cleanupSolicitado = false;

      const cleanup = () => {
        if (cleanupSolicitado) return;
        cleanupSolicitado = true;
        frame.remove();
        URL.revokeObjectURL(pdfUrl);
      };

      const imprimirPDF = () => {
        if (impressaoSolicitada) return;
        impressaoSolicitada = true;

        try {
          frame.contentWindow?.focus();
          frame.contentWindow?.print();
        } catch (error) {
          console.error('Erro ao abrir a impressão do PDF da ordem de serviço:', error);
          showMessage('Não foi possível abrir a impressão da ordem de serviço.', 'warning');
          cleanup();
        } finally {
          frame.contentWindow?.addEventListener?.('afterprint', cleanup, { once: true });
          setTimeout(cleanup, 60000);
        }
      };

      frame.onload = () => setTimeout(imprimirPDF, 300);
      setTimeout(imprimirPDF, 1200);
      return true;
    } catch (error) {
      console.error('Erro ao imprimir o PDF da ordem de serviço:', error);
      showMessage(`Erro ao imprimir a ordem de serviço!\n${error?.message || error}`, 'danger');
      return false;
    }
  }, [showMessage]);

  return (
    <PrinterOSContext.Provider value={{ imprimirOrdemServicoPDF }}>
      {children}
    </PrinterOSContext.Provider>
  );
};

export const usePrinterOS = () => {
  const context = useContext(PrinterOSContext);
  if (!context) {
    throw new Error('usePrinterOS deve ser usado dentro de PrinterOSProvider.');
  }
  return context;
};
